<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around end" style="width:100%; background-color:black; color:white; text-align: right;">

    <!--div style="text-align: left; padding:25px;">Stichting MIA Helpt<br>
        Nieuwe Jonkerstraat 4 D <br>
        1011CM Amsterdam <br>
        KVK: 54493005</div -->
    <div style="text-align: left; padding:25px;"><!--a href="privacy">privacy</a--></div>
    <div style="text-align: right; padding:25px;">© Stichting MIA Helpt, 2021<br>
        </div>
</div>